import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // Basic email regex validation
  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, message } = formData;

    // Validate required fields
    if (!name || !email || !message) {
      setError("Please fill in all fields.");
      return;
    }

    // Validate email format
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError("");
    setSuccess(true);

    // open user's mail client
    const subject = encodeURIComponent(`New message from ${name}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`
    );

    // replace with your email address
    window.location.href = `mailto:info@essajeesatelier.com?subject=${subject}&body=${body}`;
  };

  return (
    <Container
      sx={{
        py: 10,
        maxWidth: "600px !important",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#b1976b",
          mb: 3,
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
        }}
      >
        Contact Us
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2.5,
          width: "100%",
          mt: 2,
        }}
      >
        <TextField
          label="Name"
          name="name"
          variant="outlined"
          fullWidth
          value={formData.name}
          onChange={handleChange}
        />
        <TextField
          label="Email"
          name="email"
          variant="outlined"
          fullWidth
          value={formData.email}
          onChange={handleChange}
        />
        <TextField
          label="Message"
          name="message"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={formData.message}
          onChange={handleChange}
        />

        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "#b1976b",
            color: "#fff",
            fontWeight: 500,
            textTransform: "none",

            py: 1.2,
            "&:hover": {
              backgroundColor: "#a88d5d",
              fontWeight: "bold",
            },
          }}
        >
          Send Message
        </Button>
        {error && (
          <Alert severity="error" sx={{ mb: 1 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mb: 1 }}>
            Opening your mail app...
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default Contact;
